//export const environment = "local";
export const environment = "development";
//export const environment = "production";
export const MYINVOIS_API_BASE_URL = environment === 'local' ? 'http://localhost:7093/api' : environment === 'development' ? 'https://dev-api.malaysiaeinvoice.com/api' : 'https://prod-api.malaysiaeinvoice.com/api';
